<template>
	<div
		class="conversation-list-actions"
		:open-dialog="openDialog"
		:open-dialog-animation="openDialogAnimation"
		@click.self="setOpenDialog('')"
	>
		<transition
			name="dialog"
			@before-enter="openDialogAnimation = 'open'"
			@before-leave="openDialogAnimation = 'closing'"
			@after-leave="openDialogAnimation = 'closed'"
		>
			<div
				v-show="openDialog"
				class="conversation-list-action card shadow"
			>
				<div
					v-show="openDialog == 'conversation-manager'"
					class="conversation-list-action-inner"
				>
					<ConversationProviderManager />
				</div>
				<div
					v-show="openDialog == 'settings'"
					class="conversation-list-action-inner"
				>
					<Settings />
				</div>
			</div>
		</transition>
		<div
			:class="
				'openers ' + (scrolledToBottom || openDialog ? '' : 'hovering ')
			"
			:left-active="openDialog == 'conversation-manager'"
			:right-active="openDialog == 'settings'"
		>
			<button
				:class="
					'conversation-manager-btn btn action lg primary ' +
						(scrolledToBottom ||
						openDialog == 'conversation-manager'
							? 'shadow '
							: '') +
						' ' +
						(openDialog != 'conversation-manager'
							? 'rounded '
							: '') +
						(openDialog != '' &&
						openDialog != 'conversation-manager'
							? 'flat '
							: '')
				"
				@click="
					setOpenDialog(
						openDialog == 'conversation-manager'
							? ''
							: 'conversation-manager'
					)
				"
			>
				<icon>account</icon>
			</button>
			<button
				:class="
					'settings-btn btn action lg light ' +
						(scrolledToBottom || openDialog == 'settings'
							? 'shadow '
							: '') +
						' ' +
						(openDialog != 'settings' ? 'rounded ' : '') +
						(openDialog != '' && openDialog != 'settings'
							? 'flat '
							: '')
				"
				@click="
					setOpenDialog(openDialog == 'settings' ? '' : 'settings')
				"
			>
				<icon>settings</icon>
			</button>
		</div>
	</div>
</template>
<script>
import Icon from './Icon';
import ConversationProviderManager from './ConversationProviderManager.vue';
import Settings from './Settings.vue';

export default {
	name: 'ConversationListActions',
	components: {
		Icon,
		ConversationProviderManager,
		Settings
	},
	props: ['scrolledToBottom'],
	data() {
		return {
			openDialog: '',
			openDialogAnimation: 'closed'
		};
	},
	methods: {
		setOpenDialog(to = '') {
			this.openDialog = to;
			this.$emit('update:openDialog', this.openDialog);
		}
	}
};
</script>
